<template>
    <!-- NB: this content should never actually show... -->
    <div/>
</template>

<script>

import Vue from 'vue'

/**
 * Page for admin to create project for a company
 */
export default Vue.extend({
    name: 'ProjectCreate',
    props: {
        agencyId: Number,
    },
    async mounted () {
        let payload = {
            name: 'New Project'
        }
        //Prevent agencyId of 0 from causing sql errors
        if (this.agencyId && this.agencyId > 0) {
            payload['agency_id'] = this.agencyId
        }
        const response = await this.$api.createItem(this, 'project', payload)
        const projectId = response.body.id
        this.$router.replace(`/project/edit/${projectId}`)
    },
})

</script>
